export default "__VITE_ASSET__CVYnaFFj__"